module.exports = __webpack_public_path__ + "static/img/folder.16ee712c.svg";